/**
 * GP Limit Dates - Frontend Scripts
 */

( function( $ ) {

	/*
	 * String.format was deprecated in GF 2.7.1 and will be removed in GF 2.8 in favor of String.prototype.gformFormat.
	 *
	 * As we support older versions of GF, we need to add String.prototype.gformFormat if it doesn't exist.
	 */
	if ( ! String.prototype.gformFormat) {
		String.prototype.gformFormat = function () {
			var args = arguments;
			return this.replace(/{(\d+)}/g, function (match, number) {
				return typeof args[number] != 'undefined' ? args[number] : match;
			});
		};
	}

	window.GPLimitDates = {

		/**
		 * Returns true when Gravity Forms 3.0+ WhatSock (apex4x) datepicker is active.
		 * In GF 2.x, jQuery UI datepicker is used instead.
		 */
		isWhatSockMode: function() {
			return typeof $A !== 'undefined' && typeof $A.setDatepicker === 'function';
		},

		/**
		 * Return the WhatSock calendar DC instance for a given input, or null.
		 *
		 * GF 3.0 creates the calendar with id = inputId + '_calendar' and registers it
		 * in $A.reg immediately when $A.setDatepicker() is called.
		 */
		getWhatSockCalendar: function( inputId ) {
			if ( ! GPLimitDates.isWhatSockMode() ) {
				return null;
			}
			var calendarId = inputId + '_calendar';
			return ( $A.reg && $A.reg.has( calendarId ) ) ? $A.reg.get( calendarId ) : null;
		},

		/**
		 * True when a jQuery UI datepicker is attached to the given element.
		 *
		 * Other plugins can leave jQuery UI on the page alongside WhatSock, so which library drives a
		 * given element is worth asking per element rather than per page.
		 */
		hasJqueryUiDatepicker: function( $el ) {
			return ! ! ( typeof $.datepicker !== 'undefined' && $el && $el.length && $el.data( 'datepicker' ) );
		},

		/**
		 * True when the given field is configured to render an inline datepicker.
		 */
		isInlineField: function( fieldId, data ) {
			return ! ! ( data && data[ fieldId ] && data[ fieldId ].inlineDatepicker );
		},

		/**
		 * Ask Gravity Forms to initialize the datepicker for an inline field (GF 3.0+).
		 */
		requestWhatSockInit: function( inputEl, attemptsLeft ) {

			if ( inputEl.dataset.initialized ) {
				return;
			}

			// GF sets `initialized` synchronously when its handler runs, so this is a reliable check.
			inputEl.dispatchEvent( new Event( 'focusin', { bubbles: true } ) );

			if ( typeof attemptsLeft === 'undefined' ) {
				attemptsLeft = 30;
			}

			if ( ! inputEl.dataset.initialized && attemptsLeft > 0 ) {
				setTimeout( function() {
					GPLimitDates.requestWhatSockInit( inputEl, attemptsLeft - 1 );
				}, 100 );
			}

		},

		/**
		 * Render a WhatSock calendar inline, in place of the popup it would otherwise open as.
		 */
		attachInlineWhatSockCalendar: function( formId, fieldId, data ) {

			var inputEl   = document.getElementById( 'input_' + formId + '_' + fieldId ),
				container = document.getElementById( 'datepicker_' + formId + '_' + fieldId ),
				calendar  = inputEl ? GPLimitDates.getWhatSockCalendar( inputEl.id ) : null;

			if ( ! calendar || ! container || calendar.gpldInline ) {
				return;
			}

			calendar.gpldInline = true;

			// WhatSock tears down a rendered calendar when another one of the same widget type renders.
			// An inline calendar is always rendered, so opt it out.
			calendar.autoCloseSameWidget = false;

			/*
			 * WhatSock marks the day the calendar is sitting on, which follows month and year navigation
			 * rather than the date actually chosen. In a popup that reads as a cursor and Gravity Forms
			 * leaves it unstyled; inline, where the perk does style the marker, it would paint a selection
			 * on a date the visitor never picked. Suppress it and let markWhatSockSelectedDate() be the
			 * only thing that marks a day. Keyboard position is still conveyed by the focus ring.
			 */
			var createDayCell = calendar.createDayCell;
			calendar.createDayCell = function( day, date, className, isDisabled ) {
				return createDayCell.call( this, day, date, className, isDisabled, false );
			};

			GPLimitDates.preserveInlineWhatSockFocus( calendar );

			// Render into the field's own container rather than positioned against the hidden input.
			calendar.before = calendar.prepend = calendar.after = false;
			calendar.append = true;
			calendar.root   = container;

			calendar.render( function() {

				// Only now: `lock` blocks rendering as well as removal, so setting it any earlier would
				// leave the calendar unrendered.
				calendar.lock = true;

				// The widget profile marks the calendar as a non-modal dialog. True of a popup; misleading
				// for a calendar that is a permanent part of the form.
				$A.setAttr( calendar.wrapper, 'role', 'group' );
				$A.remAttr( calendar.wrapper, 'aria-modal' );

				var selected = GPLimitDates.getSelectedDate( $( inputEl ), fieldId, formId, data );

				/*
				 * jQuery UI's inline calendar always had a date selected, and the perk relies on the input
				 * carrying it so that conditional logic and Copy Cat see a value. calendar.date is
				 * WhatSock's own starting date, already clamped to the field's min and max.
				 *
				 * Limits the calendar applies per day — blocked weekdays and exception dates — can still
				 * leave it on a date the field will not accept, so leave the field empty rather than fill
				 * it with a value that fails validation on sight.
				 */
				if ( ! selected && ! data[ fieldId ].disableInlineDatePickerDefaultDate ) {
					selected = calendar.date;

					if ( ! GPLimitDates.isValidDateObject( selected ) || ! GPLimitDates.isDateShown( selected, data, fieldId )[0] ) {
						selected = null;
					}

					if ( selected ) {
						$( inputEl ).val( GPLimitDates.formatDate( selected, fieldId, data ) ).change();
					}
				}

				GPLimitDates.markWhatSockSelectedDate( calendar, selected );
				GPLimitDates.rerenderWhatSockCalendar( calendar );

			} );

		},

		/**
		 * Show which date an inline calendar has selected.
		 *
		 * Gravity Forms styles WhatSock's `dayToday` as a filled chip and gives the chosen day no styling
		 * of its own — which is fine for a popup, since picking a date closes it, but leaves an inline
		 * calendar looking permanently stuck on today. `marked` is WhatSock's persistent "Selected" state:
		 * it survives re-renders, reads as "Selected" to a screen reader, and the perk's stylesheet gives
		 * it the appearance a chosen date should have.
		 *
		 * Pass no date to clear the marker.
		 */
		markWhatSockSelectedDate: function( calendar, date ) {

			if ( ! calendar || ! calendar.range ) {
				return;
			}

			for ( var month = 0; month < 12; month++ ) {
				if ( calendar.range[ month ] ) {
					calendar.range[ month ].marked = {};
				}
			}

			if ( GPLimitDates.isValidDateObject( date ) && calendar.range[ date.getMonth() ] ) {
				calendar.range[ date.getMonth() ].marked[ date.getFullYear() ] = [ date.getDate() ];
			}

		},

		/**
		 * Unselect an inline calendar's date when a new limit leaves it out of range.
		 *
		 * An inline calendar always shows its value as selected, so keeping the value would leave a
		 * selection the calendar no longer offers. Clear both the marker and the value.
		 */
		clearOutOfRangeWhatSockDate: function( calendar, $input, fieldId, data ) {

			if ( ! calendar.gpldInline || ! $input.val() ) {
				return;
			}

			var date = GPLimitDates.parseDate( $input.val(), fieldId, data );

			if ( GPLimitDates.isValidDateObject( date ) && ! GPLimitDates.isDateInRange( date, calendar.minDate, calendar.maxDate ) ) {
				GPLimitDates.markWhatSockSelectedDate( calendar, null );
				$input.val( '' ).change();
			}

		},

		/**
		 * Stop an inline calendar from pulling focus out of the page.
		 */
		preserveInlineWhatSockFocus: function( calendar ) {

			var rerenderTable = calendar.rerenderTable,
				setFocus      = calendar.setFocus;

			calendar.rerenderTable = function() {
				calendar.gpldKeepFocus = ! ! ( calendar.container && calendar.container.contains( document.activeElement ) );
				try {
					return rerenderTable.apply( this, arguments );
				} finally {
					calendar.gpldKeepFocus = false;
				}
			};

			// Outside of a re-render, focus speaks for itself: WhatSock only calls setFocus() directly
			// while the visitor is navigating the grid.
			calendar.setFocus = function( cell, previous, suppressFocus ) {
				var keepFocus = calendar.gpldKeepFocus
					|| ! ! ( calendar.container && calendar.container.contains( document.activeElement ) );

				return setFocus.call( this, cell, previous, suppressFocus || ! keepFocus );
			};

		},

		/**
		 * Keep a GF 3.0 WhatSock calendar's month and year dropdowns naming the month on screen.
		 *
		 * WhatSock leaves a month out of its dropdown when every day in it is disabled, but its own
		 * isDisabledMonth() checks each month against the disabled dates of the month on screen rather
		 * than that month's. So once exception dates disable a whole month, paging onto it lists only the
		 * months that have more days than it does. The month shown is never among them, so the dropdown
		 * falls back to its first option and the header reads "January". A fully disabled 31-day month
		 * leaves both dropdowns empty.
		 */
		patchWhatSockMonthSelect: function( calendar ) {

			if ( ! calendar || calendar.gpldMonthSelectPatched || typeof calendar.isDisabledDate !== 'function' ) {
				return;
			}

			calendar.gpldMonthSelectPatched = true;

			calendar.isDisabledMonth = function( dc, month, year ) {

				// The dropdown can only name the month on screen if that month has an option.
				if ( dc.range.current && dc.range.current.month === month && dc.range.current.year === year ) {
					return false;
				}

				// Check the month's own disabled dates. February's range.max only tracks the year on screen.
				var monthYear = { month: month, year: year },
					days      = new Date( year, month + 1, 0 ).getDate();

				for ( var day = 1; day <= days; day++ ) {
					if ( ! dc.isDisabledDate( dc, day, new Date( year, month, day ), monthYear ) ) {
						return false;
					}
				}

				return true;
			};
		},

		/**
		 * Fix GF 3.0 WhatSock year navigation when min/max dates fall mid-year.
		 * Re-enable valid year arrows and clamp navigation to the nearest allowed date.
		 */
		patchWhatSockYearNav: function( calendar ) {

			if ( ! calendar || calendar.gpldYearNavPatched ) {
				return;
			}

			if ( typeof calendar.afterRender !== 'function' || typeof calendar.isDisabledYear !== 'function' ) {
				return;
			}

			calendar.gpldYearNavPatched = true;

			// The arrows are rebuilt on every render, so re-apply after each one.
			var originalAfterRender = calendar.afterRender;
			calendar.afterRender    = function() {
				var result = originalAfterRender.apply( this, arguments );
				GPLimitDates.refreshWhatSockYearButtons( calendar );
				return result;
			};
		},

		refreshWhatSockYearButtons: function( calendar ) {

			if ( ! calendar.range || ! calendar.range.current || ! calendar.buttons ) {
				return;
			}

			GPLimitDates.refreshWhatSockYearButton( calendar, 'pY', -1 );
			GPLimitDates.refreshWhatSockYearButton( calendar, 'nY', 1 );

			// Rebuild the arrow-key/tab order so a re-enabled arrow becomes reachable by keyboard.
			if ( typeof calendar.navUpdate === 'function' ) {
				calendar.navUpdate();
			}
		},

		/**
		 * @param {object} calendar  WhatSock calendar instance.
		 * @param {string} buttonKey Key of the arrow in calendar.buttons ('pY' or 'nY').
		 * @param {int}    offset    Years the arrow moves by: -1 for previous, 1 for next.
		 */
		refreshWhatSockYearButton: function( calendar, buttonKey, offset ) {

			var button = calendar.buttons[ buttonKey ];
			if ( ! button ) {
				return;
			}

			var $button    = $( button ),
				targetYear = calendar.range.current.year + offset;

			if ( $button.hasClass( 'disabled' ) && ! calendar.isDisabledYear( calendar, targetYear ) ) {
				$button.removeClass( 'disabled' ).removeAttr( 'aria-disabled' ).attr( 'tabindex', '0' );
				// WhatSock caches the disabled state on the node and checks it before navigating.
				$A.data( button, 'disabled', false );
			}

			// Buttons are recreated each render, so this binds once per element.
			if ( $button.data( 'gpldYearNav' ) ) {
				return;
			}

			$button.data( 'gpldYearNav', true ).on( 'click keydown', function( event ) {
				// The arrow is a role="button" cell, activated by Enter or Space.
				if ( event.type === 'keydown' && event.which !== 13 && event.which !== 32 ) {
					return;
				}
				GPLimitDates.correctWhatSockYearNav( calendar, offset );
			} );
		},

		correctWhatSockYearNav: function( calendar, offset ) {

			var yearBefore = calendar.range.current.year;

			/*
			 * Deferred so this runs after WhatSock's own handler, whichever order the two are bound in.
			 * If it managed to navigate, the year has changed and there is nothing to correct.
			 */
			setTimeout( function() {

				if ( ! calendar.range || ! calendar.range.current || calendar.range.current.year !== yearBefore ) {
					return;
				}

				var target = GPLimitDates.getWhatSockYearNavFallback( calendar, offset );
				if ( ! target ) {
					return;
				}

				calendar.date = target;
				calendar.setCurrent( calendar );
				// Deferred, so the calendar may have been closed in the meantime.
				GPLimitDates.rerenderWhatSockCalendar( calendar );
			}, 0 );
		},

		/**
		 * Where to land when paging a year would leave the allowed range: the range boundary, but only if
		 * it actually falls in the year being navigated to.
		 *
		 * That last condition is what stops us from overriding a correctly-dead arrow. Paging back from
		 * March 2026 with a minimum of 1 March 2026 targets 2025, which has nothing selectable, and the
		 * minimum date is not in 2025 — so the arrow rightly does nothing.
		 */
		getWhatSockYearNavFallback: function( calendar, offset ) {

			var targetYear = calendar.range.current.year + offset,
				month      = calendar.range.current.month,
				day        = Math.min( calendar.range.current.mDay, calendar.range[ month ].max ),
				target     = new Date( targetYear, month, day );

			// Only step in when the built-in handler really would have refused to move.
			if ( ! calendar.isOutsideDateRange( target ) ) {
				return null;
			}

			var boundary = offset < 0 ? calendar.minDate : calendar.maxDate;

			if ( ! ( boundary instanceof Date ) || boundary.getFullYear() !== targetYear ) {
				return null;
			}

			return new Date( boundary.getTime() );
		},

		/**
		 * Safely re-render a WhatSock calendar's table.
		 *
		 * WhatSock's beforeRender() reads calendar.range.current, which does not exist until the
		 * calendar has been rendered at least once (i.e. opened). Calling rerenderTable() before
		 * then throws a TypeError. Calling it after the calendar has closed throws too: the rendered
		 * nodes are detached from the document while the instance and its range survive, so
		 * afterRender() looks its month and year <select>s back up by id and gets null. Limits and
		 * disabled dates assigned to the instance are picked up by the next render regardless, so
		 * skipping the re-render here is safe.
		 */
		rerenderWhatSockCalendar: function( calendar ) {
			if ( ! calendar || typeof calendar.rerenderTable !== 'function' ) {
				return;
			}
			if ( ! calendar.range || ! calendar.range.current || ! calendar.loaded ) {
				return;
			}

			/*
			 * A new limit can leave the month on screen wholly out of range, which renders as a calendar
			 * with every day disabled and no month to pick from. WhatSock only brings the view back into
			 * range when it next opens, so a calendar that is already open has to be moved here — and an
			 * inline calendar is always open.
			 */
			var shown = new Date( calendar.range.current.year, calendar.range.current.month, calendar.range.current.mDay ),
				moveTo = null;

			if ( typeof calendar.isOutsideDateRange === 'function' && calendar.isOutsideDateRange( shown ) ) {
				if ( calendar.minDate && shown < calendar.minDate ) {
					moveTo = new Date( calendar.minDate.getTime() );
				} else if ( calendar.maxDate ) {
					moveTo = new Date( calendar.maxDate.getTime() );
				}
			}

			if ( moveTo ) {
				calendar.date = moveTo;
				calendar.setCurrent( calendar );
			}

			calendar.rerenderTable( calendar );
		},

		/**
		 * Get the effective minimum and maximum dates for a Date input, regardless of which
		 * datepicker library is in play.
		 *
		 * jQuery UI (GF 2.x) exposes these as datepicker options. WhatSock (GF 3.0+) stores them on
		 * its calendar instance, which is not registered until the calendar is first opened, so GPLD
		 * also caches them on the input itself. Without the cache, validation would treat every date
		 * as in-range until the user had opened the datepicker at least once.
		 */
		getDateLimits: function( $input ) {

			// An attached jQuery UI datepicker wins.
			if ( GPLimitDates.hasJqueryUiDatepicker( $input ) ) {
				return {
					min: $input.datepicker( 'option', 'minDate' ),
					max: $input.datepicker( 'option', 'maxDate' )
				};
			}

			if ( GPLimitDates.isWhatSockMode() ) {
				var calendar = GPLimitDates.getWhatSockCalendar( $input.attr( 'id' ) );
				if ( calendar ) {
					return { min: calendar.minDate, max: calendar.maxDate };
				}
				return { min: $input.data( 'gpldMinDate' ), max: $input.data( 'gpldMaxDate' ) };
			}

			if ( $.datepicker ) {
				return {
					min: $input.datepicker( 'option', 'minDate' ),
					max: $input.datepicker( 'option', 'maxDate' )
				};
			}

			return { min: null, max: null };
		},

		/**
		 * Format a Date as mm/dd/yyyy without depending on jQuery UI datepicker.
		 */
		formatDateMMDDYYYY: function( date ) {
			var m = date.getMonth() + 1,
				d = date.getDate(),
				y = date.getFullYear();
			return ( '0' + m ).slice( -2 ) + '/' + ( '0' + d ).slice( -2 ) + '/' + y;
		},

		init: function( formId, fieldId, data ) {

			var $input = $( '#input_' + formId + '_' + fieldId );

			// Skip composite fields (datedropdown/datefield) - they're handled in gform_post_render
			if ( ! $input.is( 'input' ) ) {
				return;
			}

			$input.change( function() {
				// Trigger onSelect functionality when the Date field value changes. This can happen when the user
				// manually enters a date value (rather than selecting it from the datepicker) or when the field value
				// is changed programmatically.
				if ( ! $( this ).data( 'gpldIgnoreChange' ) ) {
					if ( GPLimitDates.isWhatSockMode() ) {
						// WhatSock (GF 3.0+): update any dependent date fields.
						// WhatSock's default onActivate already fires 'change' on the input, so this
						// runs after the calendar closes and the value is set.
						GPLimitDates.setMinMaxDate( $( this ), fieldId, formId, data );
					} else if ( $.datepicker ) {
						// jQuery UI path: re-invoke onSelect manually.
						var inst = $.datepicker._getInst( $( this )[0] );
						if ( inst ) {
							$( this ).data( 'gpldIgnoreChange', true );
							$.datepicker._get( inst, 'onSelect' ).apply( inst.input[0], [ $( this ).datepicker( 'getDate' ), inst ] );
							$( this ).data( 'gpldIgnoreChange', false );
						}
					}
				}

				GPLimitDates.validateDate( $( this ), fieldId, data );

			} );

			GPLimitDates.validateDate( $input, fieldId, data );

		},

		isDateInRange: function( date, min, max ) {

			// An unreadable date is not "out of range", but every comparison below would report it
			// as such, since any comparison against an Invalid Date is false. Reject it up front so
			// a parse failure cannot be mistaken for a range violation.
			if ( ! GPLimitDates.isValidDateObject( date ) ) {
				return false;
			}

			if ( GPLimitDates.isValidDateObject( min ) && GPLimitDates.isValidDateObject( max ) ) {
				return date >= min && date <= max;
			} else if ( GPLimitDates.isValidDateObject( min ) ) {
				return date >= min;
			} else if ( GPLimitDates.isValidDateObject( max ) ) {
				return date <= max;
			}

			return true;
		},

		strToTime: function( text, now ) {
			/*
			discuss at: http://phpjs.org/functions/strtotime/
			version: 1109.2016
			original by: Caio Ariede (http://caioariede.com)
			improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
			improved by: Caio Ariede (http://caioariede.com)
			improved by: A. Matías Quezada (http://amatiasq.com)
			improved by: preuter
			improved by: Brett Zamir (http://brett-zamir.me)
			improved by: Mirko Faber
			input by: David
			bugfixed by: Wagner B. Soares
			bugfixed by: Artur Tchernychev
			bugfixed by: Stephan Bösch-Plepelits (http://github.com/plepe)
			*/
			var parsed, match, today, year, date, days, ranges, len, times, regex, i, fail = false;

			if ( ! text) {
				return fail;
			}

			// Unecessary spaces
			text = text.replace( /^\s+|\s+$/g, '' )
				.replace( /\s{2,}/g, ' ' )
				.replace( /[\t\r\n]/g, '' )
				.toLowerCase();

			// in contrast to php, js Date.parse function interprets:
			// dates given as yyyy-mm-dd as in timezone: UTC,
			// dates with "." or "-" as MDY instead of DMY
			// dates with two-digit years differently
			// etc...etc...
			// ...therefore we manually parse lots of common date formats
			match = text.match(
			/^(\d{1,4})([\-\.\/\:])(\d{1,2})([\-\.\/\:])(\d{1,4})(?:\s(\d{1,2}):(\d{2})?:?(\d{2})?)?(?:\s([A-Z]+)?)?$/);

			if (match && match[2] === match[4]) {
				if (match[1] > 1901) {
					switch (match[2]) {
						case '-':
							{
								// YYYY-M-D
								if (match[3] > 12 || match[5] > 31) {
									return fail;
								}

								return new Date(match[1], parseInt( match[3], 10 ) - 1, match[5],
								match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
						}
						case '.':
							{
								// YYYY.M.D is not parsed by strtotime()
								return fail;
						}
						case '/':
							{
								// YYYY/M/D
								if (match[3] > 12 || match[5] > 31) {
									return fail;
								}

								return new Date(match[1], parseInt( match[3], 10 ) - 1, match[5],
								match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
						}
					}
				} else if (match[5] > 1901) {
					switch (match[2]) {
						case '-':
							{
								// D-M-YYYY
								if (match[3] > 12 || match[1] > 31) {
									return fail;
								}

								return new Date(match[5], parseInt( match[3], 10 ) - 1, match[1],
								match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
						}
						case '.':
							{
								// D.M.YYYY
								if (match[3] > 12 || match[1] > 31) {
									return fail;
								}

								return new Date(match[5], parseInt( match[3], 10 ) - 1, match[1],
								match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
						}
						case '/':
							{
								// M/D/YYYY
								if (match[1] > 12 || match[3] > 31) {
									return fail;
								}

								return new Date(match[5], parseInt( match[1], 10 ) - 1, match[3],
								match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
						}
					}
				} else {
					switch (match[2]) {
						case '-':
							{
								// YY-M-D
								if (match[3] > 12 || match[5] > 31 || (match[1] < 70 && match[1] > 38)) {
									return fail;
								}

								year = match[1] >= 0 && match[1] <= 38 ? +match[1] + 2000 : match[1];
								return new Date(year, parseInt( match[3], 10 ) - 1, match[5],
								match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
						}
						case '.':
							{
								// D.M.YY or H.MM.SS
								if (match[5] >= 70) {
									// D.M.YY
									if (match[3] > 12 || match[1] > 31) {
										return fail;
									}

									return new Date(match[5], parseInt( match[3], 10 ) - 1, match[1],
									match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
								}
								if (match[5] < 60 && ! match[6]) {
									// H.MM.SS
									if (match[1] > 23 || match[3] > 59) {
										return fail;
									}

									today = new Date();
									return new Date(today.getFullYear(), today.getMonth(), today.getDate(),
									match[1] || 0, match[3] || 0, match[5] || 0, match[9] || 0) / 1000;
								}

								// invalid format, cannot be parsed
								return fail;
						}
						case '/':
							{
								// M/D/YY
								if (match[1] > 12 || match[3] > 31 || (match[5] < 70 && match[5] > 38)) {
									return fail;
								}

								year = match[5] >= 0 && match[5] <= 38 ? +match[5] + 2000 : match[5];
								return new Date(year, parseInt( match[1], 10 ) - 1, match[3],
								match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
						}
						case ':':
							{
								// HH:MM:SS
								if (match[1] > 23 || match[3] > 59 || match[5] > 59) {
									return fail;
								}

								today = new Date();
								return new Date(today.getFullYear(), today.getMonth(), today.getDate(),
								match[1] || 0, match[3] || 0, match[5] || 0) / 1000;
						}
					}
				}
			}

			// other formats and "now" should be parsed by Date.parse()
			if (text === 'now') {
				return now === null || isNaN( now ) ? new Date()
					.getTime() / 1000 | 0 : now | 0;
			}
			if ( ! isNaN( parsed = Date.parse( text ) )) {
				return parsed / 1000 | 0;
			}
			// Browsers != Chrome have problems parsing ISO 8601 date strings, as they do
			// not accept lower case characters, space, or shortened time zones.
			// Therefore, fix these problems and try again.
			// Examples:
			//   2015-04-15 20:33:59+02
			//   2015-04-15 20:33:59z
			//   2015-04-15t20:33:59+02:00
			if (match = text.match( /^([0-9]{4}-[0-9]{2}-[0-9]{2})[ t]([0-9]{2}:[0-9]{2}:[0-9]{2}(\.[0-9]+)?)([\+-][0-9]{2}(:[0-9]{2})?|z)/ )) {
				// fix time zone information
				if (match[4] == 'z') {
					match[4] = 'Z';
				} else if (match[4].match( /^([\+-][0-9]{2})$/ )) {
					match[4] = match[4] + ':00';
				}

				if ( ! isNaN( parsed = Date.parse( match[1] + 'T' + match[2] + match[4] ) )) {
					return parsed / 1000 | 0;
				}
			}

			date   = now ? new Date( now * 1000 ) : new Date();
			days   = {
				'sun': 0,
				'mon': 1,
				'tue': 2,
				'wed': 3,
				'thu': 4,
				'fri': 5,
				'sat': 6
			};
			ranges = {
				'yea': 'FullYear',
				'mon': 'Month',
				'day': 'Date',
				'hou': 'Hours',
				'min': 'Minutes',
				'sec': 'Seconds'
			};

			function lastNext(type, range, modifier) {
				var diff, day = days[range];

				if (typeof day !== 'undefined') {
					diff = day - date.getDay();

					if (diff === 0) {
						diff = 7 * modifier;
					} else if (diff > 0 && type === 'last') {
						diff -= 7;
					} else if (diff < 0 && type === 'next') {
						diff += 7;
					}

					date.setDate( date.getDate() + diff );
				}
			}

			function process(val) {
				var splt         = val.split( ' ' ), // Todo: Reconcile this with regex using \s, taking into account browser issues with split and regexes
					type         = splt[0],
					range        = splt[1].substring( 0, 3 ),
					typeIsNumber = /\d+/.test( type ),
					ago          = splt[2] === 'ago',
					num          = (type === 'last' ? -1 : 1) * (ago ? -1 : 1);

				if (typeIsNumber) {
					num *= parseInt( type, 10 );
				}

				if (ranges.hasOwnProperty( range ) && ! splt[1].match( /^mon(day|\.)?$/i )) {
					return date['set' + ranges[range]]( date['get' + ranges[range]]() + num );
				}

				if ( splt[1].match( /^weekdays?$/i ) ) {
					var daysRemaining    = Math.abs( num );
					var numericDirection = num < 0 ? -1 : 1;
					var weekdays         = [ 1, 2, 3, 4, 5 ];

					while ( daysRemaining > 0 ) {
						date.setDate( date.getDate() + numericDirection );

						if ( -1 !== weekdays.indexOf( date.getDay() ) ) {
							daysRemaining -= 1;
						}
					}

					return date;
				}

				if (range === 'wee') {
					return date.setDate( date.getDate() + (num * 7) );
				}

				if (type === 'next' || type === 'last') {
					lastNext( type, range, num );
				} else if ( ! typeIsNumber) {
					return false;
				}

				return true;
			}

			times = '(years?|months?|weekdays?|weeks?|days?|hours?|minutes?|min|seconds?|sec' +
			'|sunday|sun\\.?|monday|mon\\.?|tuesday|tue\\.?|wednesday|wed\\.?' +
			'|thursday|thu\\.?|friday|fri\\.?|saturday|sat\\.?)';
			regex = '([+-]?\\d+\\s' + times + '|' + '(last|next)\\s' + times + ')(\\sago)?';

			match = text.match( new RegExp( regex, 'gi' ) );
			if ( ! match) {
				return fail;
			}

			for (i = 0, len = match.length; i < len; i++) {
				if ( ! process( match[i] )) {
					return fail;
				}
			}

			// ECMAScript 5 only
			// if (!match.every(process))
			//    return false;

			return (date.getTime() / 1000);
		},

		/**
		 * Get modified date based on provided modifier.
		 *
		 * @param modifier
		 * @param date
		 * @param data
		 * @param fieldId
		 * @returns {Date}
		 */
		getModifiedDate: function( modifier, date, data, fieldId ) {
			var modifiedDate = new Date( GPLimitDates.strToTime( modifier, date.getTime() / 1000 ) * 1000 );
			return gform.applyFilters( 'gpld_modified_date', modifiedDate, modifier, date, data, fieldId );
		},

		getDateValue: function( value, key, fieldId, formId, data ) {

			var date      = null,
				isFieldId = GPLimitDates.isNumeric( value );

			if ( value == '{today}' ) {
				date = new Date();
			} else if ( isFieldId ) {
				var $input      = $( '#input_' + formId + '_' + value ),
					inputExists = $input.length > 0;

				if ( inputExists && $input.is( 'input' ) && $input.val() ) {
					date = GPLimitDates.parseDate( $input.val(), value, data );
				} else if ( inputExists && ! $input.is( 'input' ) ) {
					// Composite field (datedropdown or datefield) - construct date from parts
					var m = parseInt( $( '#input_' + formId + '_' + value + '_1' ).val(), 10 );
					var d = parseInt( $( '#input_' + formId + '_' + value + '_2' ).val(), 10 );
					var y = parseInt( $( '#input_' + formId + '_' + value + '_3' ).val(), 10 );
					if ( m && d && y ) {
						date = new Date( y, m - 1, d );
					}
				} else if ( data[ value ] && data[ value ][ key ] ) {
					// This introduces the potential for an infinite loop if two or more fields are configured with minDates dependent on each other.
					// Not sure there is elegant way to account for this...
					date = GPLimitDates.getDateValue( data[ value ][ key ], key, value, formId, data );
				}
			} else {
				date = new Date( value );
			}

			var modifier = key == 'minDate' ? data[ fieldId ].minDateMod : data[ fieldId ].maxDateMod;
			if ( modifier && GPLimitDates.isValidDateObject( date ) ) {
				date = GPLimitDates.getModifiedDate( modifier, date, data, fieldId );
			}

			if ( value == '{today}' ) {
				if ( window[ 'GPLimitDatesData' + formId ][ fieldId ].shouldUseServerTime ) {
					// only convert to server time for {today} if the filter value is true
					date = GPLimitDates.convertDateToServerTime( date, GPLimitDatesData.serverTimezoneOffset );
				}

				date.setHours( 0, 0, 0, 0 );

				// Store the timezone for PHP to use.
				const $targetElement = $( `div#field_${formId}_${fieldId}` );
				if ( $targetElement.length ) {
					const $hiddenInput = $('<input>', {
						type: 'hidden',
						name: `user_tz_${fieldId}`,
						// Set value to the visitor's timezone offset for DateTimeZone to use.
						value: date.getTimezoneOffset(),
					});

					$targetElement.after( $hiddenInput );
				}
			}

			return date;
		},

		setMinMaxDate: function( $input, fieldId, formId, data ) {

			var minFieldIds = data[ fieldId ].setsMinDateFor,
				maxFieldIds = data[ fieldId ].setsMaxDateFor;

			// Get the selected date using the appropriate API.
			var selectedDate = GPLimitDates.getSelectedDate( $input, fieldId, formId, data );

			if ( minFieldIds ) {
				$.each( minFieldIds, function( index, minFieldId ) {
					GPLimitDates.setMinDate( selectedDate, minFieldId, formId, data );
				} );
			}

			if ( maxFieldIds ) {
				$.each( maxFieldIds, function( index, maxFieldId ) {
					GPLimitDates.setMaxDate( selectedDate, maxFieldId, formId, data );
				} );
			}

		},

		/**
		 * Get the currently selected date from a datepicker input.
		 * Supports both jQuery UI (GF 2.x) and WhatSock (GF 3.0+).
		 */
		getSelectedDate: function( $input, fieldId, formId, data ) {
			if ( GPLimitDates.hasJqueryUiDatepicker( $input ) ) {
				return $input.datepicker( 'getDate' );
			}
			if ( GPLimitDates.isWhatSockMode() ) {
				var val = $input.val();
				return val ? GPLimitDates.parseDate( val, fieldId, data ) : null;
			}
			if ( $.datepicker ) {
				return $input.datepicker( 'getDate' );
			}
			return null;
		},

		refreshDependentDateLimits: function( selectedDate, sourceFieldId, formId, data ) {

			if ( ! data || ! data[ sourceFieldId ] ) {
				return;
			}

			var didUpdate = false,
				updateTargets = function( targets, setter ) {
					if ( ! targets ) {
						return;
					}

					$.each( targets, function( index, dependentFieldId ) {
						if ( ! data[ dependentFieldId ] ) {
							return;
						}

						// Only the GF 2.x inline calendar lives on its own element; on GF 3.0+ every field's
						// calendar, inline or not, is attached to the input.
						var isInline = data[ dependentFieldId ]['inlineDatepicker'] && ! GPLimitDates.isWhatSockMode(),
							selector = ( isInline ? '#datepicker_' : '#input_' ) + formId + '_' + dependentFieldId,
							$target  = $( selector );

						// jQuery UI marks its elements with 'hasDatepicker'; WhatSock uses data-initialized.
						var isInitialized = $target.hasClass( 'hasDatepicker' )
							|| ( GPLimitDates.isWhatSockMode() && ! ! $target.attr( 'data-initialized' ) );
						if ( ! $target.length || ! isInitialized ) {
							return;
						}

						var dateToApply = null;

						if ( GPLimitDates.isValidDateObject( selectedDate ) ) {
							dateToApply = new Date( selectedDate.getTime() );
						} else {
							var key        = setter === GPLimitDates.setMinDate ? 'minDate' : 'maxDate',
								configured = data[ dependentFieldId ][ key ];
							dateToApply    = GPLimitDates.getDateValue( configured, key, dependentFieldId, formId, data );
						}

						setter( dateToApply, dependentFieldId, formId, data );
						didUpdate = true;
					} );
				};

			updateTargets( data[ sourceFieldId ].setsMinDateFor, GPLimitDates.setMinDate );
			updateTargets( data[ sourceFieldId ].setsMaxDateFor, GPLimitDates.setMaxDate );

			if ( didUpdate ) {
				$( '#ui-datepicker-div' ).hide();
			}
		},

		setMinDate: function( selectedDate, fieldId, formId, data ) {

			if ( ! selectedDate ) {
				return;
			}

			// Only the jQuery UI inline calendar is a separate element; a WhatSock one is registered
			// against the input like every other field.
			var isInline = data[ fieldId ]['inlineDatepicker'] && ! GPLimitDates.isWhatSockMode(),
				$input   = isInline ? $( '#datepicker_' + formId + '_' + fieldId ) : $( '#input_' + formId + '_' + fieldId ),
				modifier = data[ fieldId ].minDateMod,
				date     = selectedDate;

			if ( modifier && GPLimitDates.isValidDateObject( date ) ) {
				date = GPLimitDates.getModifiedDate( modifier, date, data, fieldId );
			}

			// Make sure we're setting the minimum date to a valid one
			if ( GPLimitDates.isValidDateObject( date ) ) {
				while ( GPLimitDates.isDateShown( date, data, fieldId )[0] === false ) {
					date.setDate( date.getDate() + 1 );
				}
			}

			if ( GPLimitDates.isWhatSockMode() && ! GPLimitDates.hasJqueryUiDatepicker( $input ) ) {
				$input.data( 'gpldMinDate', date );
				var calMin = GPLimitDates.getWhatSockCalendar( $input.attr( 'id' ) );
				if ( calMin ) {
					calMin.minDate = date;
					if ( calMin.setDateComparisons ) {
						calMin.setDateComparisons( calMin );
					}
					GPLimitDates.clearOutOfRangeWhatSockDate( calMin, $input, fieldId, data );
					GPLimitDates.rerenderWhatSockCalendar( calMin );
				}
			} else if ( $.datepicker ) {
				$input.datepicker( 'option', 'minDate', date );
				$input.datepicker( 'refresh' );

				if ( isInline ) {
					$( $input.datepicker( 'option', 'altField' ) ).change();
				}
			}

			/**
			 * Do something after the minimum date has been set for a Date field.
			 *
			 * @since 1.0.19
			 *
			 * @param {jQuery} $input       The current Date input.
			 * @param {Date}   date         The minimum date that was set.
			 * @param {Date}   selectedDate The date selected in another Date field on which the current Date field's minimum date is dependent.
			 * @param {int}    fieldId      The ID of the current Date field.
			 * @param {int}    formId       The ID of the current form.
			 * @param {object} data         All Limit Dates data for the current form.
			 */
			gform.doAction( 'gpld_after_set_min_date', $input, date, selectedDate, fieldId, formId, data );

			/*
			 * The limit moved beneath a value the visitor already entered, and nothing else re-checks it:
			 * validateDate() otherwise only runs from the field's own change handler, which setting a limit
			 * does not fire. Skips composite fields, and GF 2.x inline fields, whose $input is a container
			 * rather than the value input; those re-validate through the altField change() above.
			 */
			if ( $input.is( 'input' ) ) {
				GPLimitDates.validateDate( $input, fieldId, data );
			}

			return date;
		},

		setMaxDate: function( selectedDate, fieldId, formId, data ) {

			if ( ! selectedDate ) {
				return;
			}

			var isInline = data[ fieldId ]['inlineDatepicker'] && ! GPLimitDates.isWhatSockMode(),
				$input   = isInline ? $( '#datepicker_' + formId + '_' + fieldId ) : $( '#input_' + formId + '_' + fieldId ),
				modifier = data[ fieldId ].maxDateMod,
				date     = selectedDate;

			if ( modifier && GPLimitDates.isValidDateObject( date ) ) {
				date = GPLimitDates.getModifiedDate( modifier, new Date( date ), data, fieldId );
			}

			if ( GPLimitDates.isWhatSockMode() && ! GPLimitDates.hasJqueryUiDatepicker( $input ) ) {
				$input.data( 'gpldMaxDate', date );
				var calMax = GPLimitDates.getWhatSockCalendar( $input.attr( 'id' ) );
				if ( calMax ) {
					calMax.maxDate = date;
					if ( calMax.setDateComparisons ) {
						calMax.setDateComparisons( calMax );
					}
					GPLimitDates.clearOutOfRangeWhatSockDate( calMax, $input, fieldId, data );
					GPLimitDates.rerenderWhatSockCalendar( calMax );
				}
			} else if ( $.datepicker ) {
				$input.datepicker( 'option', 'maxDate', date );
				$input.datepicker( 'refresh' );

				if ( isInline ) {
					$( $input.datepicker( 'option', 'altField' ) ).change();
				}
			}

			/**
			 * Do something after the maximum date has been set for a Date field.
			 *
			 * @since 1.1.4
			 *
			 * @param {jQuery} $input       The current Date input.
			 * @param {Date}   date         The maximum date that was set.
			 * @param {Date}   selectedDate The date selected in another Date field on which the current Date field's maximum date is dependent.
			 * @param {int}    fieldId      The ID of the current Date field.
			 * @param {int}    formId       The ID of the current form.
			 * @param {object} data         All Limit Dates data for the current form.
			 */
			gform.doAction( 'gpld_after_set_max_date', $input, date, selectedDate, fieldId, formId, data );

			// As in setMinDate(): re-check the entered value against the limit that just moved.
			if ( $input.is( 'input' ) ) {
				GPLimitDates.validateDate( $input, fieldId, data );
			}

			return date;
		},

		isDateShown: function( date, data, fieldId ) {

			if ( ! date ) {
				return [ true ];
			}

			var daysOfWeek       = data[ fieldId ].daysOfWeek,
				exceptions       = data[ fieldId ].exceptions,
				dateString       = GPLimitDates.formatDateMMDDYYYY( date ),
				day              = date.getDay(),
				isValidDayOfWeek = typeof daysOfWeek != 'object' || daysOfWeek.length <= 0 || daysOfWeek.indexOf( day ) != -1,
				shouldDisplay    = isValidDayOfWeek && ! data[ fieldId ].disableAll,
				classes          = [];

			if ( exceptions.indexOf( dateString ) != -1 ) {

				classes.push( 'gpld-excepted' );

				// if date is excepted, we'll need to check if it is within the date range to determine if it should display by default
				var limits      = GPLimitDates.getDateLimits( $( this ) );
				var inDateRange = GPLimitDates.isDateInRange( date, limits.min, limits.max );
				shouldDisplay   = inDateRange && isValidDayOfWeek;

				switch ( data[ fieldId ].exceptionMode ) {
					case 'enable':
						shouldDisplay = true;
						break;
					case 'disable':
						shouldDisplay = false;
						break;
					default:
						shouldDisplay = ! shouldDisplay;
						break;
				}

			}

			if ( ! shouldDisplay ) {
				classes.push( 'gpld-disabled' )
			}

			if ( ! isValidDayOfWeek ) {
				classes.push( 'gpld-disallowed-day-of-the-week' );
			}

			return [ shouldDisplay, classes.length > 0 ? classes.join( ' ' ) : '' ];
		},

		createErrorElement: function( fieldId, date, data ) {
			/**
			 * Filter to modify the Invalid Date string that's show beside the date picker if an invalid date
			 * is chosen.
			 *
			 * @since 1.0.22
			 *
			 * @param string Invalid date error message
			 * @param string|number Field ID
			 * @param jQuery Object of the Input (null for composite fields)
			 * @param Date Selected date
			 * @param Object Settings pertaining to GP Limit Dates for the current field
			 *
			 * @type string
			 */
			var invalidDateStr = window.gform.applyFilters( 'gpld_invalid_date_error', GPLimitDatesData.strings.invalidDate, fieldId, null, date, data[ fieldId ] );

			var iconSvgUrl = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogPGc+CiAgPHRpdGxlPkxheWVyIDE8L3RpdGxlPgogIDxwYXRoIGZpbGw9IiM3OTAwMDAiIGQ9Im0xNDkwLDEzMjJxMCw0MCAtMjgsNjhsLTEzNiwxMzZxLTI4LDI4IC02OCwyOHQtNjgsLTI4bC0yOTQsLTI5NGwtMjk0LDI5NHEtMjgsMjggLTY4LDI4dC02OCwtMjhsLTEzNiwtMTM2cS0yOCwtMjggLTI4LC02OHQyOCwtNjhsMjk0LC0yOTRsLTI5NCwtMjk0cS0yOCwtMjggLTI4LC02OHQyOCwtNjhsMTM2LC0xMzZxMjgsLTI4IDY4LC0yOHQ2OCwyOGwyOTQsMjk0bDI5NCwtMjk0cTI4LC0yOCA2OCwtMjh0NjgsMjhsMTM2LDEzNnEyOCwyOCAyOCw2OHQtMjgsNjhsLTI5NCwyOTRsMjk0LDI5NHEyOCwyOCAyOCw2OHoiIGlkPSJzdmdfMSIvPgogPC9nPgo8L3N2Zz4=';
			$error         = $( '<span class="gpld-error-message" style="background: transparent url( \'' + iconSvgUrl + '\' ) no-repeat center left; background-size: 18px; padding-left: 19px; color: #790000; font-size: 12px; flex-basis: 100%;">' +
			invalidDateStr + '</span>' );
			return $error;
		},

		validateDate: function( $input, fieldId, data ) {

			var date, formattedDate,
				dateVal = $input.val();

			// Normalize a date typed without separators before anything tries to parse it. The legacy
			// jQuery UI datepicker parsed the raw input itself; on GF 3.0+ the value is handed to
			// parseDate() below, which cannot read it while the separators are missing.
			var separatedDateVal = GPLimitDates.addDateSeparators( dateVal, fieldId, data );

			if ( separatedDateVal !== dateVal ) {
				dateVal = separatedDateVal;
				$input.val( dateVal );
			}

			if ( GPLimitDates.hasJqueryUiDatepicker( $input ) ) {
				date          = $input.datepicker( 'getDate' );
				formattedDate = $.datepicker.formatDate( $input.datepicker( 'option', 'dateFormat' ), date );
			} else {
				// No datepicker is attached to this element: either WhatSock is driving the field, or it is
				// a GF 2.x inline field whose calendar lives on a separate div. Either way, use the value.
				date          = dateVal ? GPLimitDates.parseDate( dateVal, fieldId, data ) : null;
				formattedDate = date ? GPLimitDates.formatDate( date, fieldId, data ) : '';
			}

			var $container = $input.parents( '.ginput_container' ),
				$error     = $container.find( 'span.gpld-error-message' );

			if ( ! date ) {
				$error.hide();
				$input.removeClass( 'gpld-error' );
				return;
			}

			// force $input to have a correctly formatted date
			if ( dateVal != formattedDate ) {
				$input.val( formattedDate );
			}

			var limits  = GPLimitDates.getDateLimits( $input );
			var isValid = ! date || ( GPLimitDates.isDateShown( date, data, fieldId )[0] && GPLimitDates.isDateInRange( date, limits.min, limits.max ) );

			if ( ! isValid ) {

				if ( $error.length <= 0 ) {
					$error = GPLimitDates.createErrorElement( fieldId, date, data );
					$container.append( $error );
				}

				$error.show();
				$input.addClass( 'gpld-error' );

			} else {

				$error.hide();
				$input.removeClass( 'gpld-error' );

			}

		},

		validateCompositeDate: function( formId, fieldId, data ) {
			var $container = $( '#input_' + formId + '_' + fieldId ),
				$inputs    = $container.find( 'input, select' ),
				$error     = $container.find( 'span.gpld-error-message' );

			// Get date parts
			var m = parseInt( $( '#input_' + formId + '_' + fieldId + '_1' ).val(), 10 ),
				d = parseInt( $( '#input_' + formId + '_' + fieldId + '_2' ).val(), 10 ),
				y = parseInt( $( '#input_' + formId + '_' + fieldId + '_3' ).val(), 10 );

			// Clear error if incomplete
			if ( ! m || ! d || ! y ) {
				$error.hide();
				$inputs.removeClass( 'gpld-error' );
				return;
			}

			// Validate date
			var date       = new Date( y, m - 1, d );
			var isRealDate = date.getFullYear() === y && date.getMonth() === (m - 1) && date.getDate() === d;

			if ( ! isRealDate ) {
				date = null;
			}

			// Check if date is valid using existing methods
			var minDate = GPLimitDates.getDateValue( data[ fieldId ].minDate, 'minDate', fieldId, formId, data );
			var maxDate = GPLimitDates.getDateValue( data[ fieldId ].maxDate, 'maxDate', fieldId, formId, data );
			var isValid = isRealDate && GPLimitDates.isDateShown( date, data, fieldId )[0] && GPLimitDates.isDateInRange( date, minDate, maxDate );

			if ( isValid ) {
				GPLimitDates.refreshDependentDateLimits( date, fieldId, formId, data );
			}

			// Show/hide error
			if ( ! isValid ) {
				if ( ! $error.length ) {
					$error = GPLimitDates.createErrorElement( fieldId, date, data );
					$container.append( $error );
				}

				$error.show();
				$inputs.addClass( 'gpld-error' );

			} else {

				$error.hide();
				$inputs.removeClass( 'gpld-error' );

			}
		},

		convertDateToServerTime: function( date, offset ) {

			var serverTimezoneOffset = offset,
				userTime             = date,
				userTimezoneOffset   = userTime.getTimezoneOffset();

			var utcTime = new Date( userTime );
			utcTime.setHours( utcTime.getHours() + Math.floor( userTimezoneOffset / 60 ) );

			var serverTime = new Date( utcTime );
			serverTime.setHours( serverTime.getHours() + Math.floor( serverTimezoneOffset / 60 ) );

			return serverTime;
		},

		isNumeric: function( value ) {
			return ! isNaN( parseFloat( value ) ) && isFinite( value );
		},

		isValidDateObject: function( date ) {
			return Object.prototype.toString.call( date ) === '[object Date]' && ! isNaN( date.getTime() );
		},

		/**
		 * Insert the field's separator into a date typed without one, e.g. '01261972' => '01/26/1972'.
		 *
		 * Any value that is not an unseparated eight digit date is returned untouched. Gravity Forms
		 * 3.0+ hands the raw input value to parseDate(), which splits on the separator, so a value
		 * typed without separators has to be normalized before it can be read at all.
		 */
		addDateSeparators: function( dateVal, fieldId, data ) {

			if ( typeof dateVal !== 'string' || dateVal.length !== 8 || ! /^\d+$/.test( dateVal ) ) {
				return dateVal;
			}

			var formatBits = ( data[ fieldId ].dateFormat || 'mdy' ).split( '_' ),
				separator  = formatBits[1] ? formatBits[1] : 'slash',
				sepChars   = { slash: '/', dot: '.', dash: '-' },
				sepChar    = sepChars[ separator ] || '/';

			switch ( formatBits[0] ) {
				// Both are two, two, then four digits; only the meaning of the parts differs.
				case 'mdy':
				case 'dmy':
					return dateVal.substring( 0, 2 ) + sepChar + dateVal.substring( 2, 4 ) + sepChar + dateVal.substring( 4 );
				case 'ymd':
					return dateVal.substring( 0, 4 ) + sepChar + dateVal.substring( 4, 6 ) + sepChar + dateVal.substring( 6 );
			}

			return dateVal;
		},

		/**
		 * Parse a JS date object from a date value based on a specific field's properties. Based on code from the
		 * GWDates class.
		 */
		parseDate: function( date, fieldId, data ) {

			// date will be undefined if date field does not exist; this can occur if date field mapped to min/max date settings is deleted
			if ( typeof date == 'undefined' ) {
				return date;
			}

			try {
				var timestamp  = false,
					formatBits = data[fieldId].dateFormat.split( '_' ),
					mdy        = formatBits[0],
					separator  = formatBits[1] ? formatBits[1] : 'slash',
					sepChars   = {slash: '/', dot: '.', dash: '-'},
					sepChar    = sepChars[separator];

				var dateArr     = date.split( sepChar ),
					month       = dateArr[mdy.indexOf( 'm' )],
					day         = dateArr[mdy.indexOf( 'd' )],
					year        = dateArr[mdy.indexOf( 'y' )],
					missingData = ! month || ! day || ! year;

				// Bail when the value did not yield all three parts. Without this, the Date below is
				// built from undefined parts and comes back as an Invalid Date object, which is
				// truthy, so every `if ( ! date )` guard downstream waves it through as a successful
				// parse.
				if ( missingData ) {
					return null;
				}

				date = new Date( year, month - 1, day, 0, 0, 0, 0 );

				return GPLimitDates.isValidDateObject( date ) ? date : null;
			} catch (err) {
			} // Field was probably deleted, fail silently to allow rest of the form to render.
		},

		formatDate: function( date, fieldId, data ) {

			var formatBits = data[ fieldId ].dateFormat.split( '_' ),
				separator  = formatBits[1] ? formatBits[1] : 'slash',
				sepChars   = { slash: '/', dot: '.', dash: '-' },
				sepChar    = sepChars[ separator ],
				mdy        = formatBits[0].split( '' ).join( sepChar ), // example: 'mdy' => 'm-d-y'
				rawMonth   = date.getMonth() + 1 + '',
				month      = '00'.substring( 0, 2 - rawMonth.length ) + rawMonth,
				// Pad the day to match the month. Gravity Forms date formats are two digit, and the
				// value written back into the input has to round trip through parseDate().
				rawDay     = date.getDate() + '',
				day        = '00'.substring( 0, 2 - rawDay.length ) + rawDay,
				year       = date.getFullYear(),
				formatted  = mdy.replace( 'm', month ).replace( 'd', day ).replace( 'y', year );

			return formatted;
		},

		setInlineDate: function( $input, fieldId, data ) {
			// deprecated - no longer used
		},

		// Deprecated in favor of the overridden _attachDatepicker method on the datepicker below.
		initDisabledDatepicker : function( _deprecated ) {
			// deprecated - noop. Kept as some other Perks such as Populate Anything call this method.
		},

		/**
		 * Apply disabled days-of-week and exception dates to a WhatSock (GF 3.0+) calendar instance.
		 *
		 * WhatSock's isDisabledDate() can only ever add restrictions: a day whose weekday is listed in
		 * calendar.range.disabledWDays is disabled whatever else the range says about that date, so an
		 * exception that makes a blocked weekday available cannot be expressed through the range at all.
		 * Instead, each day is put to isDateShown() — the rules jQuery UI's beforeShowDay applied, and the
		 * ones validation uses — while WhatSock's own check still enforces the minimum and maximum dates.
		 *
		 * @param {HTMLElement} inputEl  The date input element.
		 * @param {string|int}  fieldId  The Gravity Forms field ID.
		 * @param {object}      data     GPLD options for this form.
		 */
		applyWhatSockDisabledDates: function( inputEl, fieldId, data ) {
			var calendar = GPLimitDates.getWhatSockCalendar( inputEl.id );
			if ( ! calendar || typeof calendar.isDisabledDate !== 'function' ) {
				return;
			}

			var fieldData = data[ fieldId ];

			// As on jQuery UI, only fields that limit days of the week or have exceptions are checked per day.
			if ( ! ( fieldData.daysOfWeek && fieldData.daysOfWeek.length ) && ! ( fieldData.exceptions && fieldData.exceptions.length ) ) {
				return;
			}

			// Keep WhatSock's own check once, however many times this runs for the same calendar.
			var isDisabledDate = calendar.gpldIsDisabledDate = calendar.gpldIsDisabledDate || calendar.isDisabledDate;

			calendar.isDisabledDate = function( dc, day, date ) {
				return isDisabledDate.apply( this, arguments ) || ! GPLimitDates.isDateShown( date, data, fieldId )[0];
			};

			// Re-render if the calendar is already open.
			GPLimitDates.rerenderWhatSockCalendar( calendar );
		}

	};

	gform.addFilter( 'gform_datepicker_options_pre_init', function( optionsObj, formId, fieldId ) {

		if ( typeof formId == 'undefined' ) {
			return optionsObj;
		}

		/**
		 * Filter to modify GP Limit Dates settings data.
		 *
		 * @since 1.1.27
		 *
		 * @param Object Settings data pertaining to GP Limit Dates
		 * @param string Form ID
		 *
		 */
		var data = gform.applyFilters( 'gpld_datepicker_data', window[ 'GPLimitDatesData' + formId ], formId );

		if ( ! data || ! data[ fieldId ] ) {
			return optionsObj;
		}

		var onClose    = optionsObj.onClose,
			beforeShow = optionsObj.beforeShow,
			onSelects  = [], // Build an array of onSelect functions; combine them into a single function before returning.
			$dp        = $( '#ui-datepicker-div' );

		// Whether this field uses GF 3.0's WhatSock datepicker or the GF 2.x jQuery UI one.
		var useWhatSock = GPLimitDates.isWhatSockMode(),
			openOnFocus = data[ fieldId ].openOnFocus && ! GPLimitDates.isInlineField( fieldId, data );

		// Hide the jQuery UI datepicker by default so inline datepickers work correctly.
		// No-op on GF 3.0, where the jQuery UI datepicker is no longer used.
		$dp.hide();

		// Check for an existing onSelect func.
		if ( optionsObj.onSelect ) {
			onSelects.push( optionsObj.onSelect );
		}

		// modify optionsObj
		$.each( data[ fieldId ], function( key, value ) {

			if ( ! value || value.length <= 0 ) {
				return true; // continue
			}

			switch ( key ) {
				case 'inlineDatepicker':
					if ( useWhatSock ) {

						// WhatSock's default onActivate writes the value, closes the calendar and returns focus
						// to the input. An inline calendar never closes and its input is hidden, so only the
						// value-writing half applies.
						optionsObj.onActivate = function( event, calendar, input ) {
							input.value = calendar.formatDate( calendar );

							// Move the selected-date marker onto the day just picked. Selecting a date within
							// the displayed month does not re-render the grid on its own.
							GPLimitDates.markWhatSockSelectedDate( calendar, calendar.date );
							GPLimitDates.rerenderWhatSockCalendar( calendar );

							$A.trigger( input, 'input change' );
						};

						// Open on the month of the field's current value, as the jQuery UI inline calendar did.
						// WhatSock otherwise always starts on the current month.
						var inlineValue = $( '#input_{0}_{1}'.gformFormat( formId, fieldId ) ).val(),
							inlineDate  = inlineValue ? GPLimitDates.parseDate( inlineValue, fieldId, data ) : null;

						if ( GPLimitDates.isValidDateObject( inlineDate ) ) {
							optionsObj.initialDate = inlineDate;
						}

					} else if ( typeof $.datepicker !== 'undefined' ) {
						var $input             = $( '#input_{0}_{1}'.gformFormat( formId, fieldId ) ),
							currentDate        = new Date(),
							defaultValue       = $input.val(),
							defaultDate        = defaultValue ? defaultValue : GPLimitDates.formatDate( currentDate, fieldId, data );
						optionsObj.altField    = '#' + $input.attr( 'id' );
						optionsObj.defaultDate = defaultDate;
						// Default date is always selected; if no default date is specified, current date is used. Update
						// the $input value so conditional logic and Copy Cat will work.
						optionsObj.beforeShow = function( input, inst ) {
							beforeShow( input, inst );
							var $inline    = $( '#datepicker_{0}_{1}'.gformFormat( formId, fieldId ) );
							var dateString = $inline.datepicker( 'getDate' ) ? GPLimitDates.formatDate( $inline.datepicker( 'getDate' ), fieldId, data ) : '';
							if ( ! defaultValue || $input.val() !== dateString ) {
								// Ensure that the datepicker is visible before firing this .change() as it can cause issues
								// with conditional logic on subsequent pages.
								if ( $inline.is( ':visible' ) ) {
									$input.val( dateString ).change();
								}
							}
						};
						// Inline datepicker fails to show selected date when rendered while hidden via conditional logic;
						// force datepicker to reset the selected date after conditional logic is evaluated.
						$( document ).on( 'gform_post_conditional_logic', function() {
							var $inline = $( '#datepicker_{0}_{1}'.gformFormat( formId, fieldId ) );
							var date    = $inline.datepicker( 'getDate' );

							// If inline datepicker is disabled with `gpld_disable_inline_date_picker_default_date`,
							// ensure the current month is displayed (default behaviour) without any date selected.
							if ( ( 'disableInlineDatePickerDefaultDate' in data[ fieldId ] ) && data[ fieldId ].disableInlineDatePickerDefaultDate && $input.attr( 'value' ) === '' ) {
								// jQuery UI datepicker would visually still show the current day as selected, remove that.
								// Reference: https://stackoverflow.com/questions/52039316/jquery-ui-datepicker-without-current-date/52057750
								$inline.find( '.ui-datepicker-current-day' ).removeClass( 'ui-datepicker-current-day' );
								return;
							}

							$inline.datepicker( 'setDate', $inline.datepicker( 'getDate' ) );
						} );

						// Trigger change on initial load to accommodate conditional logic. Change is triggered in beforeShow
						// but if conditional logic is active, the is visible check will be false.
						$( document ).one( 'gform_post_conditional_logic', function() {
							if ( ! gformIsHidden( $input ) ) {
								$input.trigger( 'change' );
							}
						} );
					}
					break;
				case 'openOnFocus':
					// Gravity Forms 3.0+ disables opening its WhatSock datepicker on input focus by default.
					// Restore the opt-in behavior without changing jQuery UI datepickers on older versions.
					if ( useWhatSock && openOnFocus ) {
						optionsObj.openOnFocus = true;
					}
					break;
				case 'minDate':
					optionsObj.minDate = GPLimitDates.getDateValue( value, key, fieldId, formId, data );
					// Make sure the minimum date is selectable
					if ( GPLimitDates.isValidDateObject( optionsObj.minDate ) ) {
						while ( GPLimitDates.isDateShown( optionsObj.minDate, data, fieldId )[0] === false ) {
							optionsObj.minDate.setDate( optionsObj.minDate.getDate() + 1 );
						}
					}
					break;
				case 'maxDate':
					optionsObj.maxDate = GPLimitDates.getDateValue( value, key, fieldId, formId, data );
					break;
				case 'setsMinDateFor':
				case 'setsMaxDateFor':
					// Note: this previously used onClose(); it was updated so that it would work for inline datepickers
					// as well, since they never trigger the onClose event.
					onSelects.push( function() {

						if ( typeof onSelect == 'function' ) {
							onSelect();
						}

						var $input       = $( this ),
							isOnlyInline = true;

						if ( $.isArray( value ) ) {
							$.each( value, function( i ) {
								if ( ! data[ value[ i ] ]['inlineDatepicker'] ) {
									isOnlyInline = false;
									return false;
								}
							} );
						} else {
							isOnlyInline = data[ value ]['inlineDatepicker'];
						}

						var closeInterval = setInterval( function()  {
							if ( ! $dp.is( ':visible' ) ) {
								GPLimitDates.setMinMaxDate( $input, fieldId, formId, data );
								clearInterval( closeInterval );
							}
						}, isOnlyInline ? 0 : 200 );

					} );
					break;
				case 'daysOfWeek':
				case 'exceptions':
					// jQuery UI: use beforeShowDay callback to disable dates visually.
					// WhatSock: the calendar instance asks isDateShown() for each day after init (see below).
					if ( ! useWhatSock ) {
						optionsObj.beforeShowDay = function( date ) {
							return GPLimitDates.isDateShown( date, data, fieldId );
						};
					}
					break;
				case 'disableInlineDatePickerDefaultDate':
					optionsObj.disableInlineDatePickerDefaultDate = value;
					break;
			}
		} );

		// jQuery UI: onSelect callback chains all collected handlers.
		// In WhatSock (GF 3.0+) mode, WhatSock's built-in onActivate fires 'input change' on the
		// input element, which triggers GPLD's change handler in init() above. That handler calls
		// setMinMaxDate() to update dependent date fields — no onActivate override needed.
		if ( ! useWhatSock ) {
			optionsObj.onSelect = function( dateText, inst ) {
				for ( var i = 0; i < onSelects.length; i++ ) {
					if ( typeof onSelects[ i ] == 'function' ) {
						onSelects[ i ].call( this, dateText, inst );
					}
				}
				// If any onSelect option is passed, we must trigger the $input change event manually; not sure why.
				var $input = $( this ).is( 'input' ) ? $( this ) : $( $( this ).datepicker( 'option', 'altField' ) );
				if ( ! $input.data( 'gpldIgnoreChange' ) ) {
					$input
						.data( 'gpldIgnoreChange', true )
						.change()
						.data( 'gpldIgnoreChange', false );
				}
			};
		}

		// WhatSock (GF 3.0+): apply disabled weekdays and exception dates after $A.setDatepicker()
		// has registered the calendar DC. The filter runs synchronously before $A.setDatepicker() is
		// called, so we schedule via setTimeout(fn, 0) to run after the current call stack clears.
		if ( useWhatSock ) {
			var wsInputEl = document.getElementById( 'input_' + formId + '_' + fieldId );
			if ( wsInputEl ) {
				// Cache the initial limits so validation works before the calendar is first opened.
				$( wsInputEl )
					.data( 'gpldMinDate', optionsObj.minDate )
					.data( 'gpldMaxDate', optionsObj.maxDate );
				setTimeout( function() {
					var calendar = GPLimitDates.getWhatSockCalendar( wsInputEl.id );
					GPLimitDates.applyWhatSockDisabledDates( wsInputEl, fieldId, data );
					GPLimitDates.patchWhatSockMonthSelect( calendar );
					GPLimitDates.patchWhatSockYearNav( calendar );

					// WebKit does not emit another focus event when GF focuses an input that is already focused
					// after lazy initialization. Explicitly open the calendar if that initial focus was missed.
					if ( openOnFocus && document.activeElement === wsInputEl && calendar && ! calendar.loaded && calendar.triggerNode ) {
						$A.trigger( calendar.triggerNode, 'opendatepicker' );
					}

					// Render last, so the calendar's first paint already reflects the field's limits.
					if ( GPLimitDates.isInlineField( fieldId, data ) ) {
						GPLimitDates.attachInlineWhatSockCalendar( formId, fieldId, data );
					}
				}, 0 );
			}
		}

		// initialize related functionality
		GPLimitDates.init( formId, fieldId, data );

		return optionsObj;
	} );

	/**
	 * jQuery Datepicker doesn't fire the beforeShow method for inline datepickers. Let's override datepicker class with
	 * our own version that triggers the beforeShow method.
	 *
	 * Solution provided by StackOverflow: https://stackoverflow.com/a/12286320/227711
	 *
	 * These overrides only apply to jQuery UI (GF 2.x). In GF 3.0+ WhatSock is used instead.
	*/
	if ( typeof $.datepicker !== 'undefined' && $.datepicker._attachDatepicker ) {
		$.extend( $.datepicker, {

			// Reference the original function so we can override it and call it later.
			_origAttachDatepicker: $.datepicker._attachDatepicker,
			_origSelectMonthYear: $.datepicker._selectMonthYear,

			/*
			 * Override the _inlineDatepicker method to allow not auto-selecting a date, adding support for disabling the
			 * datepicker, and to resolve the display issues.
			 *
			 * Note, this method does not call the original as it's heavily modified.
			 */
			_inlineDatepicker: function (target, inst) {
				var divSpan = $( target );
				if ( divSpan.hasClass( this.markerClassName ) ) {
					return;
				}

				var $input = $( target );

				divSpan.addClass( this.markerClassName ).append( inst.dpDiv );
				$.data( target, "datepicker", inst );

				var formIdFieldId = divSpan.attr( 'id' ).replace( /^datepicker_/, '' ).split( '_' );
				var formId        = formIdFieldId[0];
				var fieldId       = formIdFieldId[1];

				var $hiddenInput = $( '#input_' + formId + '_' + fieldId );

				// By default, the inline datepicker widget will select a date when inline. Add support for disabling this.
				if ( ! ( 'disableInlineDatePickerDefaultDate' in inst.settings ) || ! inst.settings.disableInlineDatePickerDefaultDate || $hiddenInput.attr( 'value' ) ) {
					this._setDate( inst, this._getDefaultDate( inst ), true );
				} else {
					// If auto-selected date is disabled, we still need to select the month/year.
					var newDate    = this._getDefaultDate( inst );
					inst.drawMonth = inst.selectedMonth = inst.currentMonth = newDate.getMonth();
					inst.drawYear  = inst.selectedYear = inst.currentYear = newDate.getFullYear();
				}

				this._updateDatepicker( inst );
				this._updateAlternate( inst );

				//If disabled option is true, disable the datepicker before showing it (see ticket #5665)
				if ( inst.settings.disabled ) {
					this._disableDatepicker( target );
				}

				// Set display:block in place of inst.dpDiv.show() which won't work on disconnected elements
				// http://bugs.jqueryui.com/ticket/7552 - A Datepicker created on a detached div has zero height
				inst.dpDiv.css( "display", "block" );

				var beforeShow = $.datepicker._get( inst, 'beforeShow' );
				if ( beforeShow ) {
					beforeShow.apply( target, [ target, inst ] );
				}
			},

			/// Override the _attachDatepicker method so we can disable the Datepicker using the class.
			_attachDatepicker: function ( target, settings ) {
				var $input = $( target );

				if ($input.hasClass( 'gpro-disabled-datepicker' )) {
					settings.disabled = true;
				}

				$.datepicker._origAttachDatepicker( target, settings );

				// If the datepicker is disabled, jQuery UI will also disable the input. We don't want that as we already
				// have the readonly attribute set on it.
				$input.prop( 'disabled', false );
			},

			/*
			 * Override _selectMonthYear to prevent errors with conditional logic when using a default value
			 * Ticket: https://secure.helpscout.net/conversation/2070511880/40757?folderId=1530128
			 */
			_selectMonthYear: function( id, select, period ) {
				if ( typeof select.options[ select.selectedIndex ] === 'undefined' ) {
					return;
				}

				$.datepicker._origSelectMonthYear( id, select, period );
			},
		} );
	} // end if ($.datepicker)

	/*
	 * On GF 3.0+, ask Gravity Forms to initialize inline date fields. GF does this on first focus of the
	 * input, which an inline field's hidden input never receives.
	 *
	 * The `gform-datepicker` class is the signal for which version we are on: the perk's PHP leaves it
	 * on the input only when GF is using WhatSock, and strips it on GF 2.x so that GF's own initializer
	 * skips the field. Checking it rather than `$A` matters, because the script that defines `$A` loads
	 * asynchronously and is regularly not there yet when this runs.
	 */
	$( document ).on( 'gform_post_render', function( event, formId ) {

		var data = window[ 'GPLimitDatesData' + formId ];
		if ( ! data ) {
			return;
		}

		$.each( data, function( fieldId ) {

			if ( ! GPLimitDates.isInlineField( fieldId, data ) ) {
				return;
			}

			var inputEl = document.getElementById( 'input_' + formId + '_' + fieldId );
			if ( inputEl && inputEl.classList.contains( 'gform-datepicker' ) ) {
				GPLimitDates.requestWhatSockInit( inputEl );
			}

		} );

	} );

	// Initialize composite date field validation
	$( document ).on( 'gform_post_render', function( event, formId ) {
		var data = window[ 'GPLimitDatesData' + formId ];
		if ( ! data ) {
			return;
		}

		$.each( data, function( fieldId ) {
			var $field = $( '#input_' + formId + '_' + fieldId );

			// Initialize composite date fields only
			if ( $field.length && ! $field.is( 'input' ) && ! $field.data( 'gpldInit' ) ) {
				$field.data( 'gpldInit', true )
					.on( 'change input', 'select, input', function() {
						GPLimitDates.validateCompositeDate( formId, fieldId, data );
					});
				GPLimitDates.validateCompositeDate( formId, fieldId, data );
			}
		});
	});

} )( jQuery );
